const dictionaryCategories = [
  {
    category: "animal",
    name: [
      "tiger",
      "elephant",
      "lion",
      "dog",
      "rabbit",
      "zebra",
      "horse",
      "cat",
      "giraffe",
      "gorilla",
    ],
  },
  {
    category: "sport",
    name: [
      "cricket",
      "football",
      "baseball",
      "badminton",
      "hockey",
      "swimming",
      "tennis",
      "volleyball",
      "golf",
      "boxing",
    ],
  },
  {
    category: "food",
    name: [
      "cheese",
      "butter",
      "milk",
      "sandwich",
      "pancake",
      "bread",
      "yogurt",
      "egg",
      "honey",
      "salad",
    ],
  },
  {
    category:"human body",
    name:[
        "face",
        "eye",
        "knee",
        "liver",
        "heart",
        "kidney",
        "mouth",
        "cheek",
        "elbow",
        "abdomen"
    ]
  }
];

export default dictionaryCategories;
